<ion-list lines="none">
  <ion-item>
    <ion-icon src="/assets/icons/24px/optimize-audio.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Audio Enhancements</h3>
      </ion-text>

      <ion-text color="black">
        <p>Voice quality and clarity that make remote conversations closer to reality</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/active-speaker.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Voice Processing</h3>
      </ion-text>

      <ion-text color="black">
        <p>Knows when people are speaking to keep other sounds out of the conversation</p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
